import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
       // icon
import logobgremove from "../pages/images/logo/logobgremove.png";
import logotext from "../pages/images/logo/removebg.png";

export default function Header() {
  const navigate = useNavigate();

  return (
    <header
  className="d-flex justify-content-between align-items-center px-3 px-md-4 shadow-sm"
  style={{
    backgroundColor: "#0F0F0F",
    height: "60px",        // reduced from 75px
    paddingTop: "0px",     // remove vertical padding
    paddingBottom: "0px",
    position: "relative",
    borderBottom: "1px solid #e6d3a3",   // ✨ beige line
    zIndex: 1000
  }}
>
      {/* Logo + Brand */}
      <div
        className="d-flex align-items-center"
        style={{ cursor: "pointer", gap: "10px" }}
        onClick={() => navigate("/")}
      >
        {/* Icon */}
        <img
          src={logobgremove}
          alt="Logo"
          style={{
            width: "50px",
            height: "50px",
            objectFit: "contain"
          }}
        />

        {/* Brand Text Image */}
       <img
  src={logotext}
  alt="Orrbiit"
  style={{
    height: "500px",
    width: "auto",
    maxWidth: "100px",
    objectFit: "contain"
  }}
/>
      </div>

      {/* Right side blank for now (menu later) */}
      <div></div>
    </header>
  );
}
